module.exports = "/_next/static/images/Security-md-1fb5b7a91bbcd05f66f928e5e8e21cac.webp";